/*
 * サブシステム名：乗務員別実績帳票出力
 * 機能名：乗務員別実績帳票出力
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

import validators from '@/rahmen/validators'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import message from '@/ddv2.library/messages'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import DdAutocompleteChipBox from '@/components/DdAutocompleteChipBox.vue'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdDateBox from '@/components/DdDateBox'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdMonthRangeBox from '@/components/DdMonthRangeBox'
import DdRadioButton from '@/components/DdRadioButton'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox.vue'

export default {
  name: 'JomuinbetsuJissekiOutput',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdAutocompleteChipBox,
    DdCodeTextBox,
    DdDateBox,
    DdDateRangeBox,
    DdMonthRangeBox,
    DdRadioButton,
    DdSubHeader,
    DdTextBox
  },
  data: () => ({
    conditions: {},
    chohyoSbt: '0',
    modeKengen: 0,
    // 表示制御
    dispCsvNm: '',
    dispPdfNm: '',
    page: 1,
    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    // ----------------------------------------------------------------------------------------------------
    // 表示制御
    // ----------------------------------------------------------------------------------------------------
    keijoDayDisp: false,
    kinmuDayDisp: false,
    shukkoDayDisp: false,
    ymDisp: false,
    ymdDisp: false,
    yDisp: false,
    seikyuTomeSbtDisp: false,
    unchinKakuteiSbtDisp: false
  }),
  watch: {
    chohyoSbt: function () {
      if (this.chohyoSbt === '0') {
        this.conditions.daySbt = '01'
        this.keijoDayDisp = true
        this.kinmuDayDisp = true
        this.shukkoDayDisp = true
        this.ymDisp = false
        this.ymdDisp = true
        this.yDisp = false
        this.seikyuTomeSbtDisp = true
        this.unchinKakuteiSbtDisp = true
      } else if (this.chohyoSbt === '1') {
        this.conditions.daySbt = '02'
        this.keijoDayDisp = false
        this.kinmuDayDisp = true
        this.shukkoDayDisp = false
        this.ymDisp = false
        this.ymdDisp = true
        this.yDisp = false
        this.seikyuTomeSbtDisp = false
        this.unchinKakuteiSbtDisp = false
      } else if (this.chohyoSbt === '2') {
        this.conditions.daySbt = '02'
        this.keijoDayDisp = false
        this.kinmuDayDisp = true
        this.shukkoDayDisp = false
        this.ymDisp = true
        this.ymdDisp = false
        this.yDisp = false
        this.seikyuTomeSbtDisp = false
        this.unchinKakuteiSbtDisp = false
      } else if (this.chohyoSbt === '3') {
        this.conditions.daySbt = '02'
        this.keijoDayDisp = false
        this.kinmuDayDisp = true
        this.shukkoDayDisp = false
        this.ymDisp = false
        this.ymdDisp = true
        this.yDisp = false
        this.seikyuTomeSbtDisp = false
        this.unchinKakuteiSbtDisp = false
      } else if (this.chohyoSbt === '4') {
        this.conditions.daySbt = '02'
        this.keijoDayDisp = false
        this.kinmuDayDisp = true
        this.shukkoDayDisp = false
        this.ymDisp = false
        this.ymdDisp = true
        this.yDisp = false
        this.seikyuTomeSbtDisp = false
        this.unchinKakuteiSbtDisp = false
      } else if (this.chohyoSbt === '5') {
        this.conditions.daySbt = '02'
        this.keijoDayDisp = false
        this.kinmuDayDisp = true
        this.shukkoDayDisp = false
        this.ymDisp = false
        this.ymdDisp = false
        this.yDisp = true
        this.seikyuTomeSbtDisp = false
        this.unchinKakuteiSbtDisp = false
      } else if (this.chohyoSbt === '6') {
        this.conditions.daySbt = '02'
        this.keijoDayDisp = false
        this.kinmuDayDisp = true
        this.shukkoDayDisp = false
        this.ymDisp = true
        this.ymdDisp = false
        this.yDisp = false
        this.seikyuTomeSbtDisp = false
        this.unchinKakuteiSbtDisp = false
      }
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    filteredEigyoshoListArray () {
      var defArray = []
      const resultArray = this.filteredEigyoshoList.map(elem => {
        return {
          value: elem.eigyoshoCd,
          text: elem.eigyoshoNm
        }
      })
      return defArray.concat(resultArray)
    },
    // 営業所マスタフィルター <-- ここまで
    // 人員マスタフィルター --> ここから
    filteredVwcMstJinin () {
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredJishaJininList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.filteredVwcMstJinin.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.eigyoshoKbn !== '03' &&
        (self.eigyoshoLockFlg || t.eigyoshoCd === self.userEigyoshoCd)
      })
    },
    filteredJishaJininListArray () {
      var defArray = []
      const resultArray = this.filteredJishaJininList.map(elem => {
        return {
          value: elem.jininCd,
          text: elem.jininNmSei
        }
      })
      return defArray.concat(resultArray)
    }
    // 人員マスタフィルター <-- ここまで
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteLeaveByMenu: function (next) {
    const option = {
      nextCallback: next
    }
    this.preventTransition(option)
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'mstshubetsu'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            // ユーザ保存項目の復元
            resolve()
          })
        },
        existsIdMethod: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('★★★settingButtonStatePromise★★★', kengen.kengenKbn)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    settingStartYm: function (p) {
      this.$set(this.conditions, 'startYm', p)
    },
    settingEndYm: function (p) {
      this.$set(this.conditions, 'endYm', p)
    },
    onCsvButtonClick: function (e) {
      if (!this.clientValidate()) { return }
      this.Effects.loadStart()
      this.clearSummaryMessage()
      let post = ''
      if (this.chohyoSbt === '0') {
        this.dispCsvNm = `運行明細表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp2020/CsvDownload'
      } else if (this.chohyoSbt === '1') {
        this.dispCsvNm = `運行日報_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp2010/CsvDownload'
      } else if (this.chohyoSbt === '2') {
        this.dispCsvNm = `日計表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp2030/CsvDownload'
      } else if (this.chohyoSbt === '3') {
        this.dispCsvNm = `売上集計表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp2040/CsvDownload'
      } else if (this.chohyoSbt === '4') {
        this.dispCsvNm = `稼働集計表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp2050/CsvDownload'
      } else if (this.chohyoSbt === '5') {
        this.dispCsvNm = `年間月別売上対比表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp2060/CsvDownload'
      } else if (this.chohyoSbt === '6') {
        this.dispCsvNm = `収支実績表_${this.getTimeStamp()}.csv`
        post = '/api/v1/D2bzmp2070/CsvDownload'
      }
      this.HttpClient
        .post(post, this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.setInvalidSummaryMessage('COMI0006')
          this.Effects.loadComplete()
        })
    },
    onPdfButtonClick: function (e) {
      if (!this.clientValidate()) { return }
      this.clearSummaryMessage()
      console.log(e)
      this.Effects.loadStart()
      let post = ''
      if (this.chohyoSbt === '0') {
        this.dispPdfNm = `運行明細表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp2020/PdfDownload'
      } else if (this.chohyoSbt === '1') {
        this.dispPdfNm = `運行日報_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp2010/PdfDownload'
      } else if (this.chohyoSbt === '2') {
        this.dispPdfNm = `日計表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp2030/PdfDownload'
      } else if (this.chohyoSbt === '3') {
        this.dispPdfNm = `売上集計表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp2040/PdfDownload'
      } else if (this.chohyoSbt === '4') {
        this.dispPdfNm = `稼働集計表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp2050/PdfDownload'
      } else if (this.chohyoSbt === '5') {
        this.dispPdfNm = `年間月別売上対比表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp2060/PdfDownload'
      } else if (this.chohyoSbt === '6') {
        this.dispPdfNm = `収支実績表_${this.getTimeStamp()}.xlsm`
        post = '/api/v1/D2bzmp2070/ExcelOutput'
        this.HttpClient
          .requestFileByPost(post, this.conditions).then(data => {
            // aタグにファイル仕込んでClickする処理
            const blob = new Blob([data], { type: 'application/vnd.ms-excel.sheet.macroEnabled.12' })
            const elem = document.getElementById('pdfDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            this.setInvalidSummaryMessage('COMI0007')
            this.Effects.loadComplete()
          })
        return
      }
      this.HttpClient
        .requestFileByPost(post, this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          if (data.type === 'application/pdf') {
            const blob = new Blob([data], { type: 'application/pdf' })
            const elem = document.getElementById('pdfDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            this.setInvalidSummaryMessage('COMI0007')
            this.Effects.loadComplete()
          } else {
            this.setInvalidSummaryMessage('COMI0101')
            this.Effects.loadComplete()
          }
        })
    },
    clientValidate: function () {
      var msg
      var startYmd
      var endYmd
      if (this.dayDisp) {
        if (!this.conditions.startDay) {
          this.$refs.startDay[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
          return false
        }
        if (this.conditions.startDay && this.conditions.endDay) {
          msg = validators.compareDate(this.conditions.startDay, this.conditions.endDay)
          if (msg !== undefined) {
            this.$refs.startDay[this.Ctrls.SET_INVALID_METHOD](msg)
            this.$refs.endDay[this.Ctrls.SET_INVALID_METHOD](msg)
            return false
          }
        }
      }
      if (this.ymDisp) {
        if (!this.conditions.startYm) {
          this.$refs.startYm[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
          return false
        }
        if (this.conditions.startYm && this.conditions.endYm) {
          startYmd = Date.parse(this.conditions.startYm + '/01')
          endYmd = Date.parse(this.conditions.endYm + '/01')
          msg = validators.compareDate(startYmd, endYmd)
          if (msg !== undefined) {
            this.$refs.startYm[this.Ctrls.SET_INVALID_METHOD](msg)
            this.$refs.endYm[this.Ctrls.SET_INVALID_METHOD](msg)
            return false
          }
        }
      }
      if (this.yDisp) {
        if (!this.conditions.startY) {
          this.$refs.startY[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
          return false
        }
        if (this.conditions.startY && this.conditions.endY) {
          startYmd = Date.parse(this.conditions.startY + '/01/01')
          endYmd = Date.parse(this.conditions.endY + '/01/01')
          msg = validators.compareDate(startYmd, endYmd)
          if (msg !== undefined) {
            this.$refs.startY[this.Ctrls.SET_INVALID_METHOD](msg)
            this.$refs.endY[this.Ctrls.SET_INVALID_METHOD](msg)
            return false
          }
        }
      }
      return true
    },
    onClearButtonClick: function () {
      this.initBindVariables()
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      var today = new Date()
      // 前月とする為、getMonthの+1は不要
      var togetsu = ('000' + today.getFullYear()).slice(-4) + '/' + ('0' + (today.getMonth())).slice(-2)
      var year = ('000' + today.getFullYear()).slice(-4)
      const startDay = date.getFirstDate(today.getFullYear(), today.getMonth())
      const endDay = date.getLastDate(today.getFullYear(), today.getMonth())
      this.conditions = {
        daySbt: '01',
        seikyuTomeSbt: '99',
        unchinKakuteiSbt: '99',
        startDay: startDay,
        endDay: endDay,
        startYm: togetsu,
        endYm: togetsu,
        startY: year,
        endY: year,
        startEigyoshoCd: !this.eigyoshoLockFlg ? this.userEigyoshoCd : '',
        endEigyoshoCd: !this.eigyoshoLockFlg ? this.userEigyoshoCd : '',
        startJininCd: null,
        endJininCd: null,
        eigyoshoCdList: [],
        jininCdList: []
      }
      this.conditions.eigyoshoCdList[0] = this.userEigyoshoCd
      // 表示制御
      this.chohyoSbt = '0'
      this.keijoDayDisp = true
      this.kinmuDayDisp = true
      this.shukkoDayDisp = true
      this.ymDisp = false
      this.ymdDisp = true
      this.yDisp = false
      this.seikyuTomeSbtDisp = true
      this.unchinKakuteiSbtDisp = true
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    }
  }
}
